<script>
import { FormWizard, TabContent } from "vue-form-wizard";

import instructions from "@/components/step-form-artist/instructions";
import artist_info from "@/components/step-form-artist/artist_info";
import art_work from "@/components/step-form-artist/art_work";
import send_data from "@/components/step-form-artist/send_data";
import unitTest from "../../../helpers/unit_test.js";
import ArtistForm from "../../../model/artist_form.js";
import ArtistFormServices from "../../../services/artist_form.js";
import { swal } from "../../../helpers/handle_error.js";
import AlertError from "@/components/alert_error";
import VueQRCodeComponent from "vue-qrcode-component";
import html2canvas from "html2canvas";
import getQrCode from "../../../helpers/qrCode.js";

export default {
  components: {
    FormWizard,
    TabContent,
    instructions,
    artist_info,
    art_work,
    send_data,
    AlertError,
    "qr-code": VueQRCodeComponent,
  },
  data() {
    return {
      //Page errors.
      errors: [],

      isPrintedInformation: false,

      fullName: "",
      Id: "",
      Uuid: "",
      date: "",
      artists: [],

      artworks: [],

      showAlert: false,
    };
  },
  methods: {
    getQrCode,
    handleError(error) {
      this.showAlert = true;
      try {
        if (error.message.includes('Network Error') || error.code === 'ERR_NETWORK') 
          this.errors = ['حدث خطأ في الاتصال بالإنترنت. يرجى التحقق من الشبكة.'];
        else if (error.response.status == 422)
          this.errors = Object.values(error.response.data.errors);
        else
          this.errors = [
            `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
          ];
      } catch (error) {
        this.errors = ['حدث خطأ غير متوقع.'];
        alert(error)
      }
    },
    resetForm() {
      this.errors = [];
      swal.close();
    },
    onComplete: function () {
      swal.loading();

      var artist = new ArtistForm(this.$refs["artist_info"], this.$refs["art_work"]);

      ArtistFormServices.add(artist.toFormData())
        .then((response) => {
          let data = response.data.data;

          this.artists = data.artists.map((x) => {
            return {
              artwork_name: x.artwork_name,
              main_name: x.sub.main["name_" + this.$i18n.locale],
            };
          });
          this.fullName = data.full_name;
          this.Id = data.serial_number;
          this.date = data.created_at;
          this.Uuid = data.uuid;

          this.isPrintedInformation = true;
          this.resetForm();
        })
        .catch((error) => {
          this.handleError(error);
          swal.close();
        });
    },
    validateStep(name) {
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model);

        if (model.artworks) {
          this.artworks = model.artworks;
        }
      }
    },
    // print card
    async printThis() {
      const el = this.$refs.printcontent;
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(el, options);
      const link = document.createElement("a");
      link.setAttribute("download", this.Id + ".jpg");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream")
      );
      link.click();
    },
  },
  mounted() {
    alert(process.env.NODE_ENV);
    if (process.env.NODE_ENV == "development") {
      unitTest(this.$refs, this.$i18n.locale);
    }
  },
};
</script>

<template>
  <div style="overflow-x: hidden">
    <!-- Features start -->
    <section class="section con-all-page" id="features">
      <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-header text-center">
              <div class="con-logo">
                <img
                  height="60px"
                  src="@/assets/images/logo3.png"
                  loading="lazy"
                  alt="logo"
                />
                <a target="_blank" href="https://qadatalnasr.com"
                  ><h4>{{ $t("pages.artist.title") }}</h4></a
                >
              </div>
              <p class="sub-title">{{ $t("pages.artist.sub_title") }}</p>
            </div>
          </div>
          <div
            v-if="isPrintedInformation"
            class="text-center print-cover"
            style="min-height: calc(100vh - 333px)"
          >
            <div class="card-print con-print text-center" ref="printcontent">
              <div class="header">
                <h5>{{ $t("pages.artist.title") }}</h5>
                <p>
                  <strong>{{ $t("pages.artist.card_info.name") }}</strong
                  >{{ fullName }}
                </p>
                <p>
                  <strong>{{ $t("pages.artist.card_info.date") }}</strong
                  >{{ date }}
                </p>
                <p>
                  <strong>{{ $t("pages.artist.card_info.form_number") }}</strong
                  >{{ Id }}
                </p>
              </div>
              <div class="artwork text-center">
                <h5>{{ $t("pages.artist.card_info.artist_title") }}</h5>
                <hr />
                <ol class="centered-list mb-0">
                  <li v-for="artist in artists" :key="artist.id">
                    <p>
                      <span>{{ artist.main_name }}</span>
                      <i class="mdi mdi-chevron-left"></i>
                      <span>{{ artist.artwork_name }}</span>
                    </p>
                  </li>
                </ol>
              </div>
              <qr-code class="qr-code" :text="getQrCode(Uuid)"></qr-code>
            </div>
            <button
              type="button"
              id="btn3"
              @click="printThis"
              class="btn btn-save-qr btn-sm mt-3"
            >
              {{ $t("pages.artist.card_info.save_button") }}
            </button>
          </div>
          <div v-else class="col-lg-12" style="min-height: calc(100vh - 334px)">
            <div class="mb-5">
              <form-wizard
                color="#d59e35"
                error-color="#793524"
                step-size="xs"
                :back-button-text="$t('pages.artist.form_wizard.back_button_text')"
                :next-button-text="$t('pages.artist.form_wizard.next_button_text')"
                :finish-button-text="$t('pages.artist.form_wizard.finish_button_text')"
                @on-complete="onComplete"
              >
                <tab-content
                  :title="$t('pages.artist.form_wizard.tab-content.instructions.title')"
                  icon="mdi mdi-chevron-left"
                >
                  <instructions ref="instructions"></instructions>
                </tab-content>

                <tab-content
                  :title="$t('pages.artist.form_wizard.tab-content.artist_info.title')"
                  icon="mdi mdi-chevron-left"
                  :before-change="() => validateStep('artist_info')"
                >
                  <artist_info
                    ref="artist_info"
                    @on-validate="mergePartialModels"
                  ></artist_info>
                </tab-content>

                <tab-content
                  :title="$t('pages.artist.form_wizard.tab-content.art_work.title')"
                  icon="mdi mdi-chevron-left"
                  :before-change="() => validateStep('art_work')"
                >
                  <art_work ref="art_work" @on-validate="mergePartialModels"></art_work>
                </tab-content>

                <tab-content
                  :title="$t('pages.artist.form_wizard.tab-content.send.title')"
                  icon="mdi mdi-check-underline"
                >
                  <send_data ref="send_data" :artworks="artworks" />
                </tab-content>
              </form-wizard>
            </div>
          </div>

          <div class="col-lg-12">
            <!-- Footer start -->
            <footer class="landing-footer">
              <div class="container">
                <div class="row align-items-center">
                  <div class="col-md-6">
                    <img src="@/assets/images/logo.png" alt height="50" />
                    <span class="mx-2">{{ $t("pages.footer.title") }}</span>
                  </div>
                  <div class="col-md-6">
                    <p class="mt-1 text-md-end ltr-text d-sm-block mb-0">
                      {{ new Date().getFullYear() }} {{ $t("pages.footer.copy_right") }}
                    </p>
                  </div>
                </div>
              </div>
            </footer>
            <!-- Footer end -->
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
    <!-- Features end -->
  </div>
</template>
